import React from 'react';
import { Page, Document, StyleSheet, View } from '@react-pdf/renderer';
import CustomerCopy from '../CustomerCopy/CustomerCopy';
import CustomerFeedbackForm from '../CustomerFeedbackForm/CustomerFeedbackForm';
import Header from '../Header/Header';
import LuggageList from '../LuggageList/LuggageList';
import CarList from '../CarList/CarList';
import TellySheet from '../TellySheet/TellySheet';
import InvoiceTable from '../InvoiceTable/InvoiceTable';
import TransitPlanFormBox from '../TransitPlanFormBox/TransitPlanFormBox';
import TransitPlanCarFormBox from '../TransitPlanCarFormBox/TransitPlanCarFormBox';
import Reciept from '../Reciept/Reciept';
import FooterWithImage from '../FooterWithImage/FooterWithImage';
import HeaderWithAddress from '../HeaderWithAddress/HeaderWithAddress';
import { brandingForPdf } from '../../utils/tenantBrandingCache';
import { resolvePdfBrandColors } from '../../utils/pdfBrandColors';

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 60,
    paddingRight: 60,
    lineHeight: 1.5,
    flexDirection: 'column',
  },
});

const CreateJobPDF = ({ invoice = {}, branding: brandingOverride }) => {
  const pdfBranding = brandingForPdf(brandingOverride);
  const { primary: brandPrimary } = resolvePdfBrandColors(pdfBranding);
  const organizationLabel =
    (pdfBranding.companyName && String(pdfBranding.companyName).trim()) || 'Ace Relocations';
  const {
    consignorF,
    consignorL,
    consigneeF,
    consigneeL,
    oaddress1,
    oaddress2 = '',
    ocity,
    ostate,
    opincode,
    daddress1,
    daddress2 = '',
    dcity,
    dstate,
    dpincode,
    status,
    contact,
    car,
    carGcnno = '',
    email,
    insuranceP,
    insuranceA,
    insuranceCarP,
    insuranceCarA,
    insuranceAInText = '',
    insuranceCarAInText = '',
    type,
    date,
    gcnno,
    items,
    gst,
    isInvoiceAdded,
    isExpenseAdded,
    invoice: invoiceData,
    totalInText = '',

    // will be added later
    rupeesInNumber = '',
    chequeNo = '',
    billno,
    lrNo = '',
    bolSignaturePng,
    bolSignerName,
    bolSignedAt,
  } = invoice;

  let invoiceDetail = {
    consignor: { firstName: consignorF, lastName: consignorL },
    consignee: { firstName: consigneeF, lastName: consigneeL },
    contact,
    email,
    originAddress: [oaddress1, `${oaddress2}, ${ocity}`, `${ostate} - ${opincode}`],
    ocity,
    dcity,
    destinationAddress: [daddress1, `${daddress2}, ${dcity}`, `${dstate} - ${dpincode}`],
    status,
    car,
    insuranceP,
    insuranceA,
    insuranceCarP,
    insuranceCarA,
    type,
    date,
    gcnno,
    carGcnno,
    phone: contact,
    items,
    gst,
    // carGcnno,
    customer: {
      firstName: consignorF,
      lastName: consignorL,
      adderess: `${oaddress1}, ${oaddress2}, ${ocity} - ${opincode}`,
      contact,
      gcnno,
      carGcnno,
      birthDate: '',
      Anniversary: '',
      jobno: gcnno,
      destination: dcity,
      email,
    },
    customerDestination: {
      firstName: consignorF,
      lastName: consignorL,
      adderess: `${daddress1}, ${daddress2}, ${dcity} - ${dpincode}`,
      contact,
      gcnno,
      carGcnno,
      birthDate: '',
      Anniversary: '',
      jobno: gcnno,
      destination: dcity,
      email,
    },
    luggageListDetails: {
      ocity,
      dcity,
      gcnno,
      carGcnno,
      date,
      from: `${consignorF} ${consignorL}`,
      to: `${consigneeF} ${consigneeL}`,
      originAddress: {
        addressLine1: oaddress1,
        addressLine2: oaddress2 || `${oaddress2}, ${ocity}`,
        addressLine3: `${ocity} - ${opincode}`,
      },

      destinationAddress: {
        addressLine1: daddress1,
        addressLine2: daddress2 || `${daddress2}, ${dcity}`,
        addressLine3: `${dcity} - ${dpincode}`,
      },
    },


    carListDetails: {
      firstName: consignorF,
      lastName: consignorL,
      adderess: `${oaddress1}, ${oaddress2}, ${ocity} - ${opincode}`,
      contact,
      gcnno,
      carGcnno,
      birthDate: '',
      Anniversary: '',
      jobno: gcnno,
      destination: dcity,
      email,
    },

    tellyData: {
      fullName: `${consignorF} ${consignorL}`,
      location: ocity,
      mode: 'Road',
      gcnno,
      carGcnno,
      jobno: '??',
      origin: ocity,
      date,
      destination: dcity,
      originAddress: {
        addressLine1: oaddress1,
        addressLine2: oaddress2 || `${oaddress2}, ${ocity}`,
        addressLine3: `${ocity} - ${opincode}`,
      },

      destinationAddress: {
        addressLine1: daddress1,
        addressLine2: daddress2 || `${daddress2}, ${dcity}`,
        addressLine3: `${dcity} - ${dpincode}`,
      },
    },
    transitData: {
      fullName: `${consignorF} ${consignorL}`,
      gcnno,
      carGcnno,
      date,
      moneyInNumber: insuranceA,
      moneyInText: insuranceAInText,
      insuranceP
    },
    transitCarData: {
      fullName: `${consignorF} ${consignorL}`,
      gcnno,
      carGcnno,
      date,
      moneyInNumber: insuranceCarA,
      moneyInText: insuranceCarAInText,
      insuranceCarP
    }
  };

  if (isInvoiceAdded) {
    invoiceDetail = {
      ...invoiceDetail, reciept: {
        chequeIssuer: `${consignorF} ${consignorL}`,
        rupeesInNumber: invoiceData[0] ?.total,
        rupeesInText: invoiceData[0] ?.totalInText,
        chequeNo,
        recieptDate: invoiceData[0]?.recieptDate,
        date,
        billNo: invoiceData[0] ?.billno,
        lrNo: invoiceData[0] ?.gcnno ? invoiceData[0] ?.gcnno : invoiceData[0] ?.carGcnno,
        carLrNo: invoiceData[0] ?.gcnno && carGcnno ? carGcnno : null,
        from: ocity,
        to: dcity,
      },
      invoice: {
        name: `${consignorF} ${consignorL}`,
        ocity,
        dcity,
        invoiceNo: invoiceData[0] ?.billno,
        invoiceDate: invoiceData[0]?.invoiceDate,
        date,
        lrNo: invoiceData[0] ?.gcnno ? invoiceData[0] ?.gcnno : invoiceData[0] ?.carGcnno,
        invoiceDetails: invoiceData[0] ?.invoiceDetails,
        total: invoiceData[0] ?.total,
        totalInWords: invoiceData[0] ?.totalInText,
        paymentCity: dcity,
        gst: invoiceData[0] ?.gst,
      },
    }
  }
  const isCar = type === 'car';
  const isHouseHold = type === 'household';
  const isBoth = type === 'both';

  return (
    <Document>
      {/* household CustomerCopy */}
      {(isHouseHold || isBoth) && (
        [
          <Page key="hh-customer-copy" size="A4" style={styles.page} orientation="landscape">
            <CustomerCopy
              branding={pdfBranding}
              title="CUSTOMER COPY"
              consignor={invoiceDetail?.consignor}
              consignee={invoiceDetail?.consignee}
              originAddress={invoiceDetail?.originAddress}
              destinationAddress={invoiceDetail?.destinationAddress}
              type={isBoth ? 'household' : invoiceDetail?.type}
              gcnno={invoiceDetail?.gcnno}
              carGcnno={invoiceDetail?.carGcnno}
              date={invoiceDetail?.date}
              phone={invoiceDetail?.phone}
              ocity={ocity}
              dcity={dcity}
              bolSignaturePng={bolSignaturePng}
              bolSignerName={bolSignerName}
              bolSignedAt={bolSignedAt}
            />
          </Page>,
          <Page key="hh-truck-copy" size="A4" style={styles.page} orientation="landscape">
            <CustomerCopy
              branding={pdfBranding}
              title="TRUCK COPY"
              consignor={invoiceDetail?.consignor}
              consignee={invoiceDetail?.consignee}
              originAddress={invoiceDetail?.originAddress}
              destinationAddress={invoiceDetail?.destinationAddress}
              type={isBoth ? 'household' : invoiceDetail?.type}
              gcnno={invoiceDetail?.gcnno}
              carGcnno={invoiceDetail?.carGcnno}
              date={invoiceDetail?.date}
              phone={invoiceDetail?.phone}
              ocity={ocity}
              dcity={dcity}
              bolSignaturePng={bolSignaturePng}
              bolSignerName={bolSignerName}
              bolSignedAt={bolSignedAt}
            />
          </Page>,
        ]
      )}

      {/* Car CustomerCopy */}
      {(isCar || isBoth) && (
        [
          <Page key="car-customer-copy" size="A4" style={styles.page} orientation="landscape">
            <CustomerCopy
              branding={pdfBranding}
              title="CUSTOMER COPY"
              consignor={invoiceDetail?.consignor}
              consignee={invoiceDetail?.consignee}
              originAddress={invoiceDetail?.originAddress}
              destinationAddress={invoiceDetail?.destinationAddress}
              type={isBoth ? 'car' : invoiceDetail?.type}
              gcnno={invoiceDetail?.carGcnno}
              carGcnno={invoiceDetail?.carGcnno}
              date={invoiceDetail?.date}
              phone={invoiceDetail?.phone}
              ocity={ocity}
              dcity={dcity}
              bolSignaturePng={bolSignaturePng}
              bolSignerName={bolSignerName}
              bolSignedAt={bolSignedAt}
            />
          </Page>,
          <Page key="car-truck-copy" size="A4" style={styles.page} orientation="landscape">
            <CustomerCopy
              branding={pdfBranding}
              title="TRUCK COPY"
              consignor={invoiceDetail?.consignor}
              consignee={invoiceDetail?.consignee}
              originAddress={invoiceDetail?.originAddress}
              destinationAddress={invoiceDetail?.destinationAddress}
              type={isBoth ? 'car' : invoiceDetail?.type}
              gcnno={invoiceDetail?.carGcnno}
              carGcnno={invoiceDetail?.carGcnno}
              date={invoiceDetail?.date}
              phone={invoiceDetail?.phone}
              ocity={ocity}
              dcity={dcity}
              bolSignaturePng={bolSignaturePng}
              bolSignerName={bolSignerName}
              bolSignedAt={bolSignedAt}
            />
          </Page>,
        ]
      )}

      {/* CustomerFeedbackForm */}
      <Page size='A4' style={styles.page}>
        <Header branding={pdfBranding} />
        <CustomerFeedbackForm
          title='ORIGIN'
          customer={invoiceDetail ?.customer}
          branding={pdfBranding}
          accentColor={brandPrimary}
          carrierName={organizationLabel}
        />
      </Page>

      <Page size='A4' style={styles.page}>
        <Header branding={pdfBranding} />
        <CustomerFeedbackForm
          title='DESTINATION'
          customer={invoiceDetail ?.customerDestination}
          branding={pdfBranding}
          accentColor={brandPrimary}
          carrierName={organizationLabel}
        />
      </Page>

      {/* LuggageList */}
      {(isHouseHold || isBoth) && (invoiceDetail.items < 40 || invoiceDetail.items == 0) ?( 
      ([
        <Page key="luggage-1" size="A4" style={styles.page}>
          <LuggageList
            luggageListDetails={invoiceDetail?.luggageListDetails}
            carrierName={organizationLabel}
          />
        </Page>,
        <Page key="luggage-2" size="A4" style={styles.page}>
          <LuggageList
            luggageListDetails={invoiceDetail?.luggageListDetails}
            carrierName={organizationLabel}
          />
        </Page>,
        <Page key="luggage-3" size="A4" style={styles.page}>
          <LuggageList
            luggageListDetails={invoiceDetail?.luggageListDetails}
            carrierName={organizationLabel}
          />
        </Page>,
      ]) ) : (isHouseHold || isBoth) &&
      ([
        <Page key="luggage-1" size="A4" style={styles.page}>
          <LuggageList
            luggageListDetails={invoiceDetail?.luggageListDetails}
            carrierName={organizationLabel}
          />
        </Page>,
        <Page key="luggage-2" size="A4" style={styles.page}>
          <LuggageList
            luggageListDetails={invoiceDetail?.luggageListDetails}
            carrierName={organizationLabel}
          />
        </Page>,
        <Page key="luggage-3" size="A4" style={styles.page}>
          <LuggageList
            luggageListDetails={invoiceDetail?.luggageListDetails}
            carrierName={organizationLabel}
          />
        </Page>,
        <Page key="luggage-4" size="A4" style={styles.page}>
          <LuggageList
            luggageListDetails={invoiceDetail?.luggageListDetails}
            carrierName={organizationLabel}
          />
        </Page>,
        <Page key="luggage-5" size="A4" style={styles.page}>
          <LuggageList
            luggageListDetails={invoiceDetail?.luggageListDetails}
            carrierName={organizationLabel}
          />
        </Page>,
        <Page key="luggage-6" size="A4" style={styles.page}>
          <LuggageList
            luggageListDetails={invoiceDetail?.luggageListDetails}
            carrierName={organizationLabel}
          />
        </Page>,
      ]) 
      }

        {(isCar || isBoth) && (
        <Page size='A4' style={styles.page}>
        <Header branding={pdfBranding} />
          <CarList carListDetails={invoiceDetail?.customer} />
        </Page>
        )}

      {/* TellySheet */}
      {(isHouseHold || isBoth) && (
      <TellySheet tellyData={invoiceDetail ?.tellyData} branding={pdfBranding} />
      )}

      {/* Transit Protection Plan */}
      {(isHouseHold || isBoth) && (
      <Page size='A4' style={styles.page}>
        <View>
          <Header branding={pdfBranding} />
          <TransitPlanFormBox
            transitData={invoiceDetail ?.transitData}
            carrierName={organizationLabel}
            branding={pdfBranding}
          />
          <View style={{ border: 1 }} />
          <View style={{ height: 1, backgroundColor: brandPrimary, width: '100%', marginTop: 2 }} />
          <FooterWithImage branding={pdfBranding} />
        </View>
      </Page>
      )}

      {/* Car Transit Protection Plan */}
      {insuranceCarP && (isCar || isBoth) && (
        [
          <Page key="car-transit-plan" size="A4" style={styles.page}>
            <View>
              <Header branding={pdfBranding} />
              <TransitPlanCarFormBox
                transitData={invoiceDetail?.transitCarData}
                carrierName={organizationLabel}
                branding={pdfBranding}
              />
              <View style={{ border: 1 }} />
              <View style={{ height: 1, backgroundColor: brandPrimary, width: '100%', marginTop: 2 }} />
              <FooterWithImage branding={pdfBranding} />
            </View>
          </Page>,
        ]
      )}

      {/* Invoice */}
      {isInvoiceAdded && (
        [
          <Page key="invoice-table" size="A4" style={styles.page}>
            <View>
              <Header branding={pdfBranding} />
              <InvoiceTable
                invoice={invoiceDetail?.invoice}
                accentColor={brandPrimary}
                carrierName={organizationLabel}
                branding={pdfBranding}
              />
            </View>
          </Page>,
          <Page key="invoice-receipt" size="A4" style={styles.page} orientation="landscape">
            <View style={{ border: 1, margin: 50, padding: 10 }}>
              <HeaderWithAddress branding={pdfBranding} />
              <View style={{ marginTop: 20, padding: 10 }}>
                <Reciept reciept={invoiceDetail?.reciept} branding={pdfBranding} />
              </View>
            </View>
          </Page>,
        ]
      )}
    </Document>
  );
};

export default CreateJobPDF;
